import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import UI from 'UI';
import eventify from 'Eventify';
import _ from 'lodash';
import RCore from 'RCore';
import SMTeamLogo from '../SMTeamLogo';
import DateFormatted from '../DateFormatted';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const scoreWidth = 100;

const MatchCellHeader = styled.div`
    opacity: 0.9;
    backgroundcolor: rgba(33, 33, 33, 0.6);
    padding: 10px 10px;
    font-size: 11px;
`;

const SkewContainer = styled.div`
    transform: skew(-${props => props.theme.skins.skew.angle}deg);
    padding: 15px 0px 0;
`;

const Cell = styled.div`
    position: relative;
    margin: 3px auto;
    justify-content: center;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    .team-home {
        text-align: right;
        img {
        }
    }
    .team-away {
        text-align: left;
        img {
        }
    }
`;

const Team = styled.div`
    width: calc(50% - 60px);
    max-width: 240px;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    font-size: 36px;
    line-height: 64px;
    position: relative;

    color: ${props => props.theme.color};
    &:after {
        z-index: 1;
        position: absolute;
        content: '';
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        background-color: ${props =>
            props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor};
    }

    & > * {
        position: relative;
        z-index: 3;
        vertical-align: middle;
        display: inline-block;
    }

    .logo-box {
        position: absolute;
        min-width: 70px;
        top: 50%;
        text-align: center;
        transform: translateY(-50%) skew(${props => props.theme.skins.skew.angle}deg);
    }
    &.team-home .logo-box {
        right: 0;
    }
    &.team-away .logo-box {
        left: 0;
    }
`;

const Score = styled.div`
    position: relative;
    width: 120px;
    height: 64px;
    z-index: 4;
    position: relative;
    color: ${props => props.theme.accentTextColor};
    display: flex;
    font-size: 14px;
    line-height: 1.1;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    & > * {
        positon: relative;
        z-index: 6;
    }
    &:after {
        z-index: 1;
        position: absolute;
        content: '';
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border: 1px solid ${props => props.theme.content.accentTextColor};
        background-color: ${props => props.theme.content.accentColor};
        opacity: 0.9;
    }

    .top-sub {
        font-size: 20px;
        line-height: 1em;
        font-weight: 700;
        text-transform: uppercase;
    }
    .top-sub-score {
        font-size: 32px;
        font-weight: 700;
    }
    .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        line-height: 34px;
        font-weight: 700;
        flex-grow: 1.2;
    }

    .tv-info {
        width: 100%;
        flex-grow: 1;
        display: flex;
        text-transform: uppercase;
        font-weight: 15px;
        font-weight: 700;
        align-items: center;
        justify-content: center;
        backgroundcolor: rgba(0, 0, 0, 0.5);
        font-size: 14px;
    }
`;

const IsLiveLabel = styled.div`
    background: ${props => props.theme.primaryColor};
    color: ${props => props.theme.primaryTextColor};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    transform: translate(0, -50%) rotate(-90deg);
    position: absolute;
    width: 60px;
    height: 30px;
    line-height: 22px;
    box-sizing: border-box;
    padding: 3px 0 5px;
    left: -15px;
    top: 50%;
    transform-origin: center;
`;

const TeamNameHome = styled.div`
    display: inline-block;
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;
    box-sizing: border-box;
    width: 100%;
    padding-right: 70px;

    transform: skew(${props => props.theme.skins.skew.angle}deg);
`;

const TeamNameAway = TeamNameHome.extend`
    text-align: left;
    padding-left: 70px;
    padding-right: 0px;
    transform: skew(${props => props.theme.skins.skew.angle}deg);
`;

class MatchCell extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        moment: PropTypes.func,
    };

    render() {
        let { event, lang } = this.props;
        event = eventify(event);

        const tvInfo = event.channel && event.channel.name && <div className="tv-info">{event.channel.name}</div>;
        const isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
        const isFinished = event.isFinished();
        const isComing = event.isComing();
        const isLive = event.isLive();

        return (
            <Cell>
                {isLive && <IsLiveLabel>Live</IsLiveLabel>}
                <Team className="team-home">
                    <TeamNameHome>{event.homeShortName}</TeamNameHome>
                    <span className="logo-box">
                        <SMTeamLogo tournamentId={event.tournamentTemplateId} teamId={event.homeId} height={40} />
                    </span>
                </Team>
                <Score isLive={isLive}>
                    {isFinished && (
                        <div>
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                        </div>
                    )}
                    {isLive && (
                        <div>
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                            {tvInfo}
                        </div>
                    )}
                    {event.isCancelled() && <div className="">{i18('status.short.cancelled', lang)}</div>}
                    {event.isPostponed() && <div className="">{i18('status.short.postponed', lang)}</div>}
                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        isToday && (
                            <div>
                                <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                                {tvInfo}
                            </div>
                        )}
                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        !isToday && (
                            <div>
                                <div className="top-sub">
                                    <DateFormatted className="time" el="div" date={event.startDate} type="DATE_SHORT" />
                                    <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                                </div>
                            </div>
                        )}
                </Score>
                <Team className="team-away">
                    <span className="logo-box">
                        <SMTeamLogo tournamentId={event.tournamentTemplateId} teamId={event.awayId} height={40} />
                    </span>
                    <TeamNameAway>{event.awayShortName}</TeamNameAway>
                </Team>
            </Cell>
        );
    }
}

MatchCell.propTypes = {
    event: PropTypes.object.isRequired,
};

const Container = ({ children }) => <SkewContainer>{children}</SkewContainer>;

export default { MatchCellHeader, MatchCell, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/matchCell/SkewMatchCell.js
 **/